"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NameplateOEMCodes;
(function (NameplateOEMCodes) {
    NameplateOEMCodes["PASSENGER"] = "Passenger";
})(NameplateOEMCodes = exports.NameplateOEMCodes || (exports.NameplateOEMCodes = {}));
